export default __webpack_public_path__ + "static/12_16-66a42a1f1b9143c958adfc1b861c74a5.png";